module.exports = __webpack_public_path__ + "img/18.4df10f14.png";